export default (ref: unknown) => Object.keys(ref).length === 0 && ref.constructor === Object
